// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card[data-v-2d4ba55c]{box-shadow:0 4px 16px 0 rgba(0,0,0,.12);background-repeat:no-repeat;background-size:cover;background-position:50%}", ""]);
// Exports
module.exports = exports;
